import { matchPath, Outlet, useLocation } from "react-router-dom";
import TopBar from "./Topbar/TopBar";
import Drawer from "./Dawer/Drawer";
import { Page } from "./Dawer/drawerTypes";
import { useAppSelector } from "../hooks";
import { DrawerItems } from "./Dawer/DrawerConfig";
import { hasPermission } from "../Features/Shared/Login/hasPermission";
import { Psychology } from "@mui/icons-material";
import { GlobalNotification } from "./GlobalNotification";

const Layout = () => {
    const location = useLocation();
    const permissions = useAppSelector((state) => state.auth.permissions)

    const authorizedItems = DrawerItems.filter(item => {
        const requirements = item.requirements;

        if (!requirements) return true;

        return hasPermission(
            permissions,
            requirements.permission,
            requirements.level,
        );
    });

    const getPage = (): Page => {
        const match = authorizedItems.find(
            (item) => item.path === location.pathname
        );
    
        if (match) {
            return {
                label: match.label,
                icon: match.icon,
                type: match.type,
                iconType: match.iconType
            };
        };

        if (matchPath('/ProductDetail/:productId', location.pathname)) {
            return {
                label: 'Product Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }

        if (location.pathname.includes('/OrderDetail/')) {
            return {
                label: 'Order Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }
        
        if (location.pathname.includes('/BidDetails/')) {
            return {
                label: 'Bid Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }

        if (location.pathname.includes('/Nudges/')) {
            return {
                label: 'Nudge Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }

        if (location.pathname.includes('/Customers/')) {
            return {
                label: 'Customer Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }

        if (location.pathname.includes('/TodoList')) {
            return {
                label: 'Todo List',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }
        
        if (location.pathname.includes('/Locations/')) {
            return {
                label: 'Location Detail',
                icon: 'fa fa-lg fa-arrow-left',
                iconType: 'fa',
                type: 'back',
            }
        }

        if (location.pathname.includes('/PIM')) {
            return {
                label: 'PIM Agent',
                icon: Psychology,
                iconType: 'mui',
                type: 'link',
            }
        }

        if (location.pathname.includes('/AskJiro')) {
            return {
                label: 'AskJiro',
                icon: Psychology,
                iconType: 'mui',
                type: 'link',
            }
        }

        return {
            label: "Hirsch Command Center",
            icon: "fa fa-lg fa-home",
            iconType: "fa",
            type: "link",
        };
    }

    return (
        <div className="app-container">
            <TopBar page={getPage()}/>
            <Drawer />
            <div className="page-content">
                <Outlet />
            </div>
            <GlobalNotification />
        </div>
    )
};

export default Layout;
